const ensureScheme = (url) => {
  if (!url) return url

  if (!url.match(/^https?:\/\//)) {
    return `https://${url}`
  }

  return url
}

const preventScheme = (url) => {
  if (!url) return url

  return url.replace(/^https?:\/\//, '')
}

export {
  ensureScheme,
  preventScheme
}
